<script setup lang="ts">
import type { Schemas } from "#shopware";

const props = defineProps<{
  box: any;
}>();

const isVideo = computed(() => {
  const fileExtension = props.box?.diy_box_image?.fileExtension?.toLowerCase();
  return ["mp4", "webm", "ogg"].includes(fileExtension);
});
</script>

<template>
  <div class="md:w-1/2 px-1 md:px-2">
    <figure
      v-if="box?.diy_box_image?.url"
      class="img-cover aspect-square md:aspect-squre2 rounded-3xl overflow-hidden mb-8"
    >
      <template v-if="isVideo">
        <video class="w-full h-full object-cover" controls loop muted>
          <source :src="box?.diy_box_image?.url" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </template>
      <template v-else>
        <NuxtImg
          format="webp"
          loading="lazy"
          :src="box?.diy_box_image?.url"
          :alt="box?.diy_box_image?.alt || box?.diy_box_image?.name"
          :width="box?.diy_box_image?.metaData?.width"
          :height="box?.diy_box_image?.metaData?.height"
        />
      </template>
    </figure>

    <div class="hidden md:block">
      <h4 class="mb-1">{{ box.diy_box_step }} {{ box.diy_box_number }}</h4>
      <p>
        {{ box.diy_box_text }}
      </p>
      <p class="mt-4" v-if="box.diy_box_tip">
        {{ box.diy_box_tip }}
      </p>
    </div>
  </div>
</template>
